/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import { TextField, Icon } from 'bs-unified-ui'
import { useTheme } from '@mui/material/styles'

const Input = ({
  field,
  form,
  inputProps,
  error,
  helperText,
  disabled,
  ...props
}) => {
  const theme = useTheme()
  const [show, setShow] = useState(false)

  return (
    <TextField
      error={
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
      }
      helperText={
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name))
      }
      inputProps={{
        ...field,
        ...inputProps,
        value: field.value ?? '',
      }}
      sx={{
        '& input:-internal-autofill-selected, input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
          {
            WebkitTextFillColor: `${theme.foreground.black} !important`,
          },
      }}
      disabled={disabled || !!form.values?.__readOnly}
      hasValue={field.value}
      endAdornment={
        props?.type === 'password' && (
          <div
            role="presentation"
            onClick={() =>
              !(disabled || !!form.values?.__readOnly) && setShow(!show)
            }
            style={{
              cursor: !(disabled || !!form.values?.__readOnly)
                ? 'pointer'
                : 'unset',
            }}
          >
            {show ? (
              <Icon
                name="eye"
                type="fill"
                color={theme.background.outlineDivider}
              />
            ) : (
              <Icon
                name="eye-off"
                type="fill"
                color={theme.background.outlineDivider}
              />
            )}
          </div>
        )
      }
      {...props}
      type={
        props?.type === 'password' ? (show ? 'text' : 'password') : props?.type
      }
    />
  )
}

Input.defaultProps = {
  inputProps: {},
  error: '',
  helperText: '',
  disabled: false,
}

Input.propTypes = {
  inputProps: PropTypes.shape(),
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
}

export default Input
